import styled from 'styled-components';

export const ClickableWrapper = styled.div(
  ({ theme }) => `
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing[3]}px;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`
);
